import React, { useRef } from "react";
import useFocusTrap from "./useFocusTrap";
import { colors, shadows } from "./tokens";

function ModalA11yWrapper({
  open,
  onClose,
  initialFocusRef,
  labelledBy,
  describedBy,
  role = "dialog",
  backdropStyle,
  containerStyle,
  children,
}) {
  const containerRef = useRef(null);

  useFocusTrap({ containerRef, open, initialFocusRef, onClose });

  if (!open) return null;

  const handleBackdropMouseDown = (e) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  return (
    <div
      className="modal-a11y-backdrop"
      onMouseDown={handleBackdropMouseDown}
      style={{
        position: "fixed",
        inset: 0,
        background: colors.overlayBackdrop,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        ...backdropStyle,
      }}
    >
      <div
        role={role}
        aria-modal="true"
        aria-labelledby={labelledBy}
        aria-describedby={describedBy}
        ref={containerRef}
        tabIndex={-1}
        className="modal-a11y-container"
        style={{
          background: colors.surface,
          border: `1px solid ${colors.border}`,
          borderRadius: 10,
          boxShadow: shadows.lg,
          maxHeight: "90vh",
          overflowY: "auto",
          minWidth: 320,
          ...containerStyle,
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default ModalA11yWrapper;
